import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import CardsOnFileListByContact from "./cardonfileslist.component.jsx";
import BankAccountsOnFileListByContact from "./bankaccountonfileslist.component.jsx";

class OnFileListByContact extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            contactId: this.props.contactId || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            contactId: nextProps.contactId || '',
        })
    }

    render() {
        return (
            <div>
                <h5 className="mt-3">
                    <FormattedMessage
                        id="customers.on_file.cards_label"
                        defaultMessage="Cards"
                    />
                </h5>
                <CardsOnFileListByContact contactId={this.state.contactId} className="mb-3" />
                <h5>
                    <FormattedMessage
                        id="customers.on_file.bank_accounts_label"
                        defaultMessage="Bank accounts"
                    />
                </h5>
                <BankAccountsOnFileListByContact contactId={this.state.contactId} />
            </div>
        );
    }
}

export default OnFileListByContact





// WEBPACK FOOTER //
// ./src/customer/onfilelist.component.jsx